module.exports = __webpack_public_path__ + "static/media/uptoweb_logo.e1c6ce5a.jpeg";